// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Json_decode from "../../../../../node_modules/@glennsl/bs-json/src/Json_decode.bs.js";
import * as TdsFormStatus from "../types/TdsFormStatus.bs.js";

function paymentOwnerDecode(data) {
  return {
          uuid: Json_decode.field("uuid", Json_decode.string, data),
          mobile: Json_decode.field("mobile", Json_decode.string, data),
          ownerPan: Json_decode.field("pan_number", Json_decode.string, data),
          ownerName: Json_decode.field("name", Json_decode.string, data),
          place: Json_decode.field("geo_region_name", Json_decode.string, data),
          regdAddress: Json_decode.field("address", Json_decode.string, data)
        };
}

function execute(data) {
  var ownerData = Json_decode.field("payment_owner", paymentOwnerDecode, data);
  return {
          ownerName: ownerData.ownerName,
          regdAddress: ownerData.regdAddress,
          financialYearStartDate: Json_decode.field("financial_year_start_date", Json_decode.date, data),
          financialYearEndDate: Json_decode.field("financial_year_end_date", Json_decode.date, data),
          ownerPan: ownerData.ownerPan,
          place: ownerData.place,
          pdfLink: Json_decode.optional((function (param) {
                  return Json_decode.field("declaration_url", Json_decode.string, param);
                }), data),
          status: TdsFormStatus.fromString(Json_decode.field("status", Json_decode.string, data))
        };
}

var StateMapper = {
  paymentOwnerDecode: paymentOwnerDecode,
  execute: execute
};

export {
  StateMapper ,
  
}
/* No side effect */
